export default "__VITE_ASSET__YbGmPGK9__"